import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FileArchive } from 'lucide-react';
import { cn } from '@/lib/utils';
import { toast } from 'sonner';

// Stores the file globally so NewSkillAgentPage can pick it up without router state
let _pendingZipFile: File | null = null;
export function getPendingZipFile(): File | null { return _pendingZipFile; }
export function clearPendingZipFile(): void { _pendingZipFile = null; }

export function DropSkillZone() {
  const [isDragOver, setIsDragOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleFile = (file: File) => {
    if (!file.name.endsWith('.zip') && !file.name.endsWith('.skill')) {
      toast.error(t('skills.dropskillzone.el_archivo_debe_ser_un_zip'));
      return;
    }
    _pendingZipFile = file;
    navigate('/skills-agentes/new');
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) handleFile(file);
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setIsDragOver(true); }}
      onDragLeave={() => setIsDragOver(false)}
      onDrop={handleDrop}
      onClick={() => inputRef.current?.click()}
      className={cn(
        'col-span-full flex cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed p-8 transition-all',
        isDragOver
          ? 'border-primary bg-primary/5 scale-[1.01]'
          : 'border-muted-foreground/25 hover:border-primary/50 hover:bg-accent/40'
      )}
    >
      <FileArchive className={cn('h-8 w-8', isDragOver ? 'text-primary' : 'text-muted-foreground/50')} />
      <p className="font-medium text-sm">{t('skills.dropzone.title')}</p>
      <p className="text-xs text-muted-foreground">{t('skills.dropzone.subtitle')}</p>
      <input
        ref={inputRef}
        type="file"
        accept=".zip,.skill"
        className="hidden"
        onChange={(e) => { const f = e.target.files?.[0]; if (f) handleFile(f); }}
      />
    </div>
  );
}
